import React, { useEffect, useState } from 'react'
import Submenu from '../../UI/menu/submenu/Submenu'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';

const SubmenuWriteOff = () => {

    const [list, setList] = useState([])

    useEffect(() => {
        setMenu()
    }, [])

    const setMenu = () => {
        const listTemp = []

        listTemp.push({
            url: '/write-off/acts',
            name: 'Акти',
            ico: <FormatListBulletedIcon />,
        })

        setList(listTemp)
    }
    
  return (
    <Submenu 
        list={list}
    />
  )
}

export default SubmenuWriteOff